var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135.351,
    height: 67.75,
    viewBox: "0 0 135.351 67.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#27aae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.275,
    y1: 0.754,
    x2: 0.615,
    y2: 0.394,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27aae1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.085,
    y1: 0.115,
    x2: 0.682,
    y2: 0.936,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.498,
    y1: 0.721,
    x2: 0.52,
    y2: 4.341,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 0.513,
    y1: 2.095,
    x2: 0.5,
    y2: -0.01,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 0.498,
    y1: 0.115,
    x2: 0.502,
    y2: 1.87,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 0.497,
    y1: -0.537,
    x2: 0.504,
    y2: 1.811,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 0.073,
    y1: 0.378,
    x2: 0.948,
    y2: 0.844,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-91.024 -13)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(91.024 13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429.982,468.6a6.961,6.961,0,0,1-.638.49c.128-.129,7.063-7.25-3.1-20.457-8.869-13.564-.178-22.737,2.8-25.305-2.2,2.275-9.42,12.041.027,23.479C437.395,456.887,431.731,466.432,429.982,468.6Z",
    transform: "translate(-422.361 -402.37)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.531,463.615c1.748-2.168,7.412-11.714-.912-21.793-9.446-11.438-2.229-21.2-.027-23.479.5-.431.84-.676.907-.724-.376.284-8.724,6.8-.608,19.83C453.535,453.415,445.9,461.614,443.531,463.615Z",
    transform: "translate(-435.909 -397.384)",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.182,606.548q-1.532.1-3.083.105a26.226,26.226,0,0,1-9.383-1.628A22.753,22.753,0,0,1,508.2,603.9c.048-.428.081-.865.1-1.313a22.41,22.41,0,0,0-.825-6.567c-.131-.477-.27-.964-.43-1.455a1.228,1.228,0,0,0-.038-.128c-.053-.162-.112-.325-.169-.491-.121-.349-.251-.7-.386-1.053a32.516,32.516,0,0,0-1.332-3c-.126-.251-.255-.5-.395-.747l-.1-.167-.313-.53c-.227-.393-.459-.821-.714-1.308-.024-.044-.043-.084-.067-.127h3.43a14.281,14.281,0,0,0,.549,1.965c.015.049.029.1.048.148a13.632,13.632,0,0,0,1.293,2.639,12.257,12.257,0,0,0,.83,1.156q.289.369.608.708a12.486,12.486,0,0,0,4.259,2.964,13.292,13.292,0,0,0,4.358,1.02c-.017.233-.025.469-.025.707A10.013,10.013,0,0,0,523.182,606.548Z",
    transform: "translate(-493.23 -545.282)",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.551,526.1v15.563a10.028,10.028,0,0,0-9.2-6.548V535.1H618.339v-9Z",
    transform: "translate(-593.473 -492.099)",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.938,603.7v7.562c-.11.058-.221.117-.331.173a34.213,34.213,0,0,1-8.5,3.077,44.094,44.094,0,0,1-6.3.893,10.013,10.013,0,0,1-4.3-8.232c0-.237.009-.473.025-.707.391.028.788.042,1.194.042a17.847,17.847,0,0,0,5.394-.718,20.1,20.1,0,0,0,3.617-1.464v-7.174A10.028,10.028,0,0,1,643.938,603.7Z",
    transform: "translate(-598.86 -554.135)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.333,303.866c2.281-2.406,9.251-12.085-.1-23.4-8.341-10.1-2.639-19.663-.9-21.807a7.8,7.8,0,0,1,.655-.506c-.2.209-4.821,5.1-.755,14.155q.39.87.892,1.792a33.778,33.778,0,0,0,2.969,4.507q.318.483.605.961a25.918,25.918,0,0,1,1.36,2.56C539.43,293.7,532.073,301.5,529.333,303.866Z",
    transform: "translate(-511.814 -258.148)",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.188,307.35c-.348.3-.621.514-.784.637a11.609,11.609,0,0,0,3.633-6.062,12.688,12.688,0,0,0,.335-2.481,13.768,13.768,0,0,0-.124-2.479,16.011,16.011,0,0,0-.539-2.481,20.884,20.884,0,0,0-1.172-3.1,25.456,25.456,0,0,0-1.314-2.479c-.117-.206-.241-.41-.372-.62q-.845-1.273-1.543-2.48c-.5-.849-.936-1.68-1.321-2.479-6.151-12.678.066-19.375,2.2-21.187-1.737,2.144-7.439,11.707.9,21.807C529.439,295.264,522.47,304.944,520.188,307.35Z",
    transform: "translate(-502.67 -261.631)",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.18,375.49l-8.6,1.228-.071.01H570.5c-2.015-8.056-10.977-7.118-14.274-6.479q-.287-.478-.605-.96a33.8,33.8,0,0,1-2.969-4.507q-.5-.921-.892-1.792c13.682-2.751,20.551.782,23.992,4.783l.114.135A14.55,14.55,0,0,1,579.18,375.49Z",
    transform: "translate(-535.342 -348.837)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.695,431.6h-9l1.493-2.479h6.182C482.759,429.917,483.2,430.748,483.695,431.6Z",
    transform: "translate(-468.058 -407.425)",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.709,556.158a12.685,12.685,0,0,1-.335,2.481H488.7l-1.457-2.481Z",
    transform: "translate(-479.007 -518.346)",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.926,474.577h-13.1l.376-2.479h11.407A25.447,25.447,0,0,1,480.926,474.577Z",
    transform: "translate(-462.06 -444.951)",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.082,516.549h-13.2l-1.255-2.481h13.914A16,16,0,0,1,485.082,516.549Z",
    transform: "translate(-464.505 -481.596)",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.995,
    cy: 0.995,
    r: 0.995,
    transform: "translate(15.113 61.781)",
    fill: "#2b3976"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.658,
    cy: 1.658,
    r: 1.658,
    transform: "translate(10.471 64.434)",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.995,
    cy: 0.995,
    r: 0.995,
    transform: "translate(3.285 16.816)",
    fill: "#27aae1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.658,
    cy: 1.658,
    r: 1.658,
    transform: "translate(1.295 12.174)",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.321,
    cy: 2.321,
    r: 2.321,
    transform: "translate(4.611 6.869)",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.175,415.122l-8.6,1.228-.071.01a10.837,10.837,0,0,1,5.247-8.953l.114.135A14.55,14.55,0,0,1,708.175,415.122Z",
    transform: "translate(-664.336 -388.469)",
    fill: "url(#p)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(145.511 41.595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.131,862.9a7.6,7.6,0,0,1-1.957.761,8.991,8.991,0,0,1-2.078.244,6.3,6.3,0,0,1-2.314-.411,5.408,5.408,0,0,1-1.819-1.157,5.194,5.194,0,0,1-1.2-1.789,6.039,6.039,0,0,1-.426-2.307,5.812,5.812,0,0,1,.449-2.322,5.233,5.233,0,0,1,1.241-1.781,5.735,5.735,0,0,1,1.842-1.15,6.17,6.17,0,0,1,2.269-.411,6.567,6.567,0,0,1,2.048.32,4.386,4.386,0,0,1,1.759,1.1l-.959,1a3.676,3.676,0,0,0-1.332-.914,4.219,4.219,0,0,0-1.606-.32,4.372,4.372,0,0,0-1.721.335,4.164,4.164,0,0,0-2.291,2.345,5.052,5.052,0,0,0,0,3.578,4.279,4.279,0,0,0,.914,1.424,4.092,4.092,0,0,0,1.408.937,4.757,4.757,0,0,0,1.812.335,6.289,6.289,0,0,0,1.37-.16,5.461,5.461,0,0,0,1.309-.464v-3.3H287.37V857.6h3.761Z",
    transform: "translate(-281.341 -852.572)",
    fill: "#022e63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.531,854.732h1.2l4.583,10.78h-1.492l-1.1-2.649h-5.39l-1.111,2.649h-1.446Zm.579,1.644h-.03l-2.238,5.3h4.4Z",
    transform: "translate(-389.992 -854.457)",
    fill: "#022e63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.1,854.732h1.279v9.592h4.933v1.188H536.1Z",
    transform: "translate(-503.777 -854.457)",
    fill: "#022e63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.1,854.732h6.775v1.188h-5.5v3.38h5.131v1.188H633.38v3.837h5.77v1.188H632.1Z",
    transform: "translate(-587.596 -854.457)",
    fill: "#022e63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.259,854.732h1.614l6.243,8.953h.03v-8.953h1.279v10.78h-1.614l-6.242-8.953h-.031v8.953h-1.279Z",
    transform: "translate(-681.158 -854.457)",
    fill: "#022e63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.5,854.749a1.883,1.883,0,0,0-.853-.754,2.716,2.716,0,0,0-1.112-.236,3.336,3.336,0,0,0-.838.107,2.49,2.49,0,0,0-.738.32,1.6,1.6,0,0,0-.526.563,1.644,1.644,0,0,0-.2.822,1.712,1.712,0,0,0,.114.647,1.358,1.358,0,0,0,.373.51,2.764,2.764,0,0,0,.7.426,9.621,9.621,0,0,0,1.081.4q.624.2,1.21.427a4.075,4.075,0,0,1,1.035.578,2.571,2.571,0,0,1,.716.876,3.3,3.3,0,0,1-.053,2.718,2.93,2.93,0,0,1-.845.982,3.667,3.667,0,0,1-1.211.579,5.276,5.276,0,0,1-1.416.19,5.4,5.4,0,0,1-.944-.084,4.533,4.533,0,0,1-.906-.259,3.664,3.664,0,0,1-.815-.457,2.751,2.751,0,0,1-.655-.693l1.1-.9a2.252,2.252,0,0,0,.974.9,2.983,2.983,0,0,0,1.325.3,2.947,2.947,0,0,0,.83-.122,2.51,2.51,0,0,0,.754-.358,1.95,1.95,0,0,0,.548-.586,1.522,1.522,0,0,0,.213-.807,1.722,1.722,0,0,0-.167-.815,1.5,1.5,0,0,0-.518-.54,4,4,0,0,0-.883-.411l-1.249-.426a7.887,7.887,0,0,1-1.066-.419,3.269,3.269,0,0,1-.845-.578,2.47,2.47,0,0,1-.563-.822,2.907,2.907,0,0,1-.206-1.15,2.774,2.774,0,0,1,1.127-2.322,3.735,3.735,0,0,1,1.172-.586,4.966,4.966,0,0,1,3.037.083,3.266,3.266,0,0,1,1.347.982Z",
    transform: "translate(-788.866 -852.572)",
    fill: "#022e63"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.441d69a4490347952349d973a9238c7a.svg";
export { ForwardRef as ReactComponent };